import store from '@/store'
import router from '@/router'
let inactivityTimer = null;
const DEFAULT_TIMEOUT_MIN = 15;

function logoutUser() {
    // use your existing Vuex mutation via an action or directly
    store.commit('clearUserData');

    // redirect to login
    router.push({ name: 'SignIn' }).catch(() => {});
}


function resetTimer(timeoutMinutes = DEFAULT_TIMEOUT_MIN) {
    if (inactivityTimer) {
        clearTimeout(inactivityTimer);
    }

    const timeoutMs = timeoutMinutes * 60 * 1000;

    inactivityTimer = setTimeout(() => {
        logoutUser();
    }, timeoutMs);
}

function activityListener() {
    resetTimer();
}
export function initSessionTimeout(timeoutMinutes = DEFAULT_TIMEOUT_MIN) {
    // Only start once
    window.addEventListener('mousemove', activityListener);
    window.addEventListener('keydown', activityListener);
    window.addEventListener('click', activityListener);
    window.addEventListener('touchstart', activityListener);

    resetTimer(timeoutMinutes);
}

export function stopSessionTimeout() {
    window.removeEventListener('mousemove', activityListener);
    window.removeEventListener('keydown', activityListener);
    window.removeEventListener('click', activityListener);
    window.removeEventListener('touchstart', activityListener);

    if (inactivityTimer) {
        clearTimeout(inactivityTimer);
        inactivityTimer = null;
    }
}
